module.exports = __webpack_public_path__ + "media/images/gm_icon05-15f07ace60efe01ab156c411c5377e0e.png";